import { QUOTE_STATUSES } from '@views/screens/Shipment/components/QuoteCard/constants';
import type { Moment } from 'moment';
import moment from 'moment-timezone';

export const convertToTimeZone = (dateValue: Moment | string): Moment => {
  const originalDateTime = dateValue.toString();
  const originalTimeZone = 'Etc/GMT+0';

  const originalMoment = moment.tz(originalDateTime, originalTimeZone);

  const targetTimeZone = moment.tz.guess();

  const targetMoment = originalMoment.clone().tz(targetTimeZone);

  const targetDateTime = targetMoment;

  return targetDateTime;
};

export const fields = [
  'quoteNo',
  'quoteTitle',
  'status',
  'currencyCode',
  'quoteCost',
  'quoteTransportationProvider',
] as const;

export const bidExpirationRules = (
  bidExpirationDateValue?: Moment | string | null,
  quoteStatus?: string,
  isReset?: boolean,
  needValidate: boolean = false,
) => [
  {
    validator: () => {
      if (!bidExpirationDateValue && needValidate) {
        return Promise.reject('Set Bid Expiration');
      }

      if (isReset && quoteStatus === QUOTE_STATUSES.openForBid) {
        return Promise.reject('Bid Expiration cannot be empty if the status is Open for Bid');
      }

      return Promise.resolve();
    },
  },
];
